import { axiosInstance } from "./axios";
import { IError } from "dto/IError";
import { IMobywatelQRCodeResponse } from "dto/Activation/IMobywatelQRCodeResponse";
import { ICreateEDeliveryAddresResponse } from "dto/EDelivery/ICreateEDeliveryAddresResponse";
import useCustomMutation from "hooks/useCustomMutation";
import { EDeliveryRequestType } from "dto/EDelivery/EDeliveryRequestType";

const uploadStatement = (file: File): Promise<{ data: IError }> => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post(`/activate/statement`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const useUploadStatement = () => {
  return useCustomMutation(uploadStatement);
};

const getStatement = (): Promise<{ data: Blob }> => {
  return axiosInstance.get(`/activate/statement`, {
    responseType: "blob",
  });
};

const useGetStatement = () => {
  return useCustomMutation(getStatement);
};

const getMObywatelQRcode = (): Promise<{
  data: IMobywatelQRCodeResponse;
}> => {
  return axiosInstance.get(`/mobywatel/qrcode`);
};

const useGetMObywatelQRcode = () => {
  return useCustomMutation(getMObywatelQRcode);
};

export interface ICreateEDeliveryAddresRequest {
  Type: EDeliveryRequestType;
  Context: number;

  ProfessionalTitle?: string | null;
  CompanyName?: string | null;
  NIP?: string | null;
  REGON?: string | null;
  KRS?: string | null;

  LegalForm?: number | null;
  NipStatus?: number | null;

  Ade?: string | null;

  CorrespondenceAddress?: IAddress;
  HeadquartersAddress?: IAddress;
  Pdf?: string;
}

export interface ITransferEDeliveryAddresRequest
  extends ICreateEDeliveryAddresRequest {
  EDeliveryAddress: string;
}

export interface IAddress {
  Street?: string;
  PostalCode?: string;
  City?: string;
  BuildingNumber?: string;
  FlatNumber?: string;
  PostalOffice?: string;

  PostOfficeBox?: string;
  Voivodeship?: string;
  District?: string;
  Community?: string;
}

export interface ICreateEDeliveryAddressResponse {
  Id: string;
  Signature: string;
}

const createEDeliveryAddress = (
  payload: ICreateEDeliveryAddresRequest
): Promise<{ data: ICreateEDeliveryAddresResponse }> => {
  return axiosInstance.post("/edelivery/address/create", payload);
};

const useCreateEDeliveryAddress = () => {
  return useCustomMutation(createEDeliveryAddress);
};

const transferEDeliveryAddress = (
  payload: ITransferEDeliveryAddresRequest
): Promise<{ data: ICreateEDeliveryAddresResponse }> => {
  return axiosInstance.post("/edelivery/address/transfer", payload);
};

const useTransferEDeliveryAddress = () => {
  return useCustomMutation(transferEDeliveryAddress);
};

const generateRequestPdf = (
  payload: ICreateEDeliveryAddresRequest
): Promise<{ data: Blob }> => {
  return axiosInstance.post("/edelivery/address/request/pdf", payload, {
    responseType: "blob",
  });
};

const useGenerateRequestPdf = () => {
  return useCustomMutation(generateRequestPdf);
};

export interface IUpdateCompanyDataRequest {
  Name: string;
  NIP?: string;
  KRS?: string;
  REGON?: string;

  LegalFrom?: number;
  FirstName: string;
  LastName: string;

  HeadquartersAddress: IAddress;
  CorrespondenceAddress?: IAddress;
}

const updateCompanyData = (payload: IUpdateCompanyDataRequest) => {
  return axiosInstance.post("/activation/companyData", payload);
};

const useUpdateCompanyData = () => {
  return useCustomMutation(updateCompanyData);
};

export default {
  useGetStatement,
  useUploadStatement,
  useCreateEDeliveryAddress,
  useTransferEDeliveryAddress,
  useGetMObywatelQRcode,
  useGenerateRequestPdf,
  useUpdateCompanyData,
};
